import classes from "./SmallCharts.module.css";
import { useContext, useEffect, useState } from "react";
import ChartLine from "../ChartLine";
import { useLocation } from "react-router-dom";
import { LoadingRise } from "../../UI/spinners/LoadingSpinners";

import { chartsUrls } from "../../../../SMARTCITY/hardCodeData/DATA";
import { useTranslation } from "react-i18next";
import LanguageContext from "../../../hooks/language-context";

const SmallCharts = (props) => {
  console.log("PROPS DETAILS:", props.details);
  const [activeCategory, setActiveCategory] = useState(1);
  const [statisticData, setStatisticData] = useState([]);
  const [loading, setLoading] = useState(false);
  const { search } = useLocation();

  const { t } = useTranslation();
  const languageCtx = useContext(LanguageContext);

  const controller = new AbortController();
  const { signal } = controller;

  const selectCategory = (category) => {
    setActiveCategory(category);
  };

  useEffect(() => {
    const sensorId = new URLSearchParams(search).get("sensorId");

    if (sensorId)
      getSensorStats(sensorId).catch((error) => console.warn(error));
  }, [search, activeCategory, languageCtx]);

  const getSensorStats = async (sensorId) => {
    // console.log("ir8a", sensorId, activeCategory);
    setStatisticData([]);
    setLoading(true);
    const response = await fetch(
      `${chartsUrls}&sensor=${sensorId}&period=${activeCategory}&lang=${languageCtx.languageCode}`,
      { signal }
    ).catch((error) => console.warn(error));
    if (response === undefined || !response.ok) {
      setLoading(false);
      return;
    }

    const data = await response.json();
    const statsData = data.filter((item) =>
      props.loop.includes(item.parameter_id)
    );
    setStatisticData(statsData);
    setLoading(false);
    // console.log(statsData);
  };

  const findMinMax = (type) => {
    const values = props.details.map((item) => Number(item.val));

    if (type === "max") {
      return Math.max(...values);
    } else {
      return Math.min(...values);
    }
  };

  return (
    <div className={classes.small_statistics_container}>
      {/* <div>
        <button
          type={"button"}
          className={
            activeCategory === 1 ? classes.active : classes.button_switch
          }
          onClick={() => selectCategory(1)}
        >
          {t("Ημερήσια")}
        </button>
        <button
          type={"button"}
          className={
            activeCategory === 3 ? classes.active : classes.button_switch
          }
          onClick={() => selectCategory(3)}
        >
          {t("Εβδομαδιαία")}
        </button>
      </div> */}

      {!("loop" in props) && (
        <ChartLine
          size={"small"}
          data={{
            parameter_id: "28",
            name: "Ηλεκτροφωτισμός",
            description: "Κατάσταση Λαμπτήρα",
            unit: "",
            dec: "0",
            min: findMinMax("min"),
            max: findMinMax("max"),
            details: props.details,
            avg:
              props.details.reduce((acc, cv) => acc + Number(cv.val), 0) /
              props.details.length,
          }}
          type={1}
        />
      )}

      {statisticData.map((item, index) => (
        <ChartLine
          key={index}
          size={"small"}
          data={item}
          type={activeCategory}
        />
      ))}

      {loading && (
        <div style={{ minHeight: "calc(369px*3)" }}>
          <div style={{ minHeight: "369px", position: "relative" }}>
            <LoadingRise />
          </div>
        </div>
      )}
    </div>
  );
};
export default SmallCharts;
